import React from "react";
import './aboutMe.scss';

export const AboutMe = () => {
  return (
    <section id="about" className="about-me-div" aria-labelledby="about-heading">
      <h2 id="about-heading">About</h2>
      <p>
        I am a Front-end Developer (React.js Developer), a passionate programmer, and a Software developer with a keen eye for design and a drive to deliver exceptional user experiences. I'm on a mission to transform ideas into interactive and visually stunning web applications.
        Currently working as a Software Engineer at Natwest Group. Having an overall 3.5 years of experiences as a Frontend Developer.
      </p>
      <ul className="list" aria-label="Key skills and expertise">
        <li>💻 Expert in HTML, CSS, JavaScript, typescript, and modern frontend frameworks like React and next.js.</li>
        <li>🎨 Strong design sensibilities, ensuring that not only the functionality but also the aesthetics of a website are top-notch.</li>
        <li>🛠️ Proficient with responsive web design and cross-browser compatibility.</li>
        <li>📐 Dedicated to creating intuitive and user-friendly interfaces.</li>
        <li>🧩 Always excited to collaborate with teams to turn concepts into reality.</li>
      </ul>
    </section>
  )
}